export default "__VITE_ASSET__2QSEoCER__"